import { createSelector } from 'reselect'

export const getIsServer = createSelector(
  (state) => Boolean(state && state.ads && state.ads.detail && state.ads.detail.isServer),
  (isServer) => isServer
)
